import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/room'

export const roomService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
};

//index
function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

//search
function search(offset, max, data) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', data)
}

//show
function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

//save
function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

//update
function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

//delete
function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}